import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AttachmentListCpt = _resolveComponent("AttachmentListCpt");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "page",
    title: "附件详情"
  }, {
    default: _withCtx(() => [_createVNode(_component_AttachmentListCpt, {
      businessId: $data.businessId,
      attachmentType: $data.attachmentType,
      flag: $data.flag
    }, null, 8, ["businessId", "attachmentType", "flag"])]),
    _: 1
  });
}